const loadingLabel = "Laden";
const nlBE = {
  loadingLabel
};
export {
  nlBE as default,
  loadingLabel
};
